import { useEffect } from 'react';
import { initializeControls } from '@atlassian/browser-storage-controls';
import { initControlsOnce } from '@atlassian/jira-browser-storage-controls/src/utils/init-once/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFedRamp } from '@atlassian/atl-context';

export const BrowserStorageControlsInit = () => {
	useEffect(() => {
		if (fg('jfp-magma-ssr-cookie-cb')) {
			initControlsOnce();
			// changes to below logic need to be reflected in jira/src/packages/platform/browser-storage-controls/src/utils/init-once/index.tsx
		} else if (fg('fedramp-cookies-controls')) {
			initializeControls({
				product: 'Jira',
				webStorageEnabled: fg('jfp-vulcan-browser-storage-migration'),
				perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial',
			});
		} else {
			initializeControls({
				product: 'Jira',
				webStorageEnabled: fg('jfp-vulcan-browser-storage-migration'),
			});
		}
	}, []);

	return null;
};
